/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CardBasic: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.5 4C2.84315 4 1.5 5.34315 1.5 7V17C1.5 18.6569 2.84315 20 4.5 20H19.5C21.1569 20 22.5 18.6569 22.5 17V7C22.5 5.34315 21.1569 4 19.5 4H4.5ZM3.5 7C3.5 6.44772 3.94772 6 4.5 6H19.5C20.0523 6 20.5 6.44772 20.5 7V17C20.5 17.5523 20.0523 18 19.5 18H4.5C3.94772 18 3.5 17.5523 3.5 17V7ZM7.25 9H10.25C10.3881 9 10.5 9.11193 10.5 9.25V11.25C10.5 11.3881 10.3881 11.5 10.25 11.5H7.25C7.11193 11.5 7 11.3881 7 11.25V9.25C7 9.11193 7.11193 9 7.25 9Z'
      fill='currentColor'
    />
  </React.Fragment>
)
